import { useEffect } from "react";
import {
  sendUserDisconnectedStatusBeacon,
  updateUserConnectionStatus,
} from "../services/auth";

export function useConnectionStatus() {
  const updateUserStatus = async (isConnected) => {
    await updateUserConnectionStatus(isConnected);
  };
  useEffect(() => {
    updateUserStatus(true);
    if (navigator.connection) {
      navigator.connection.addEventListener("change", () =>
        updateUserStatus(true)
      );
    }
    const sendBeacon = () => sendUserDisconnectedStatusBeacon();
    window.addEventListener("beforeunload", sendBeacon);
    return () => {
      window.removeEventListener("beforeunload", sendBeacon);
    };
  }, []);
}
